import React from 'react';
import { scaleToSize } from '../../../_helpers';
import MediaService from '../../../../utils/DeviationMediaService';
import BlurredBackground from '../BlurredBackground/BlurredBackground';
import s from './Paywall.scss';
var PaywallLayout = function (_a) {
    var icon = _a.icon, title = _a.title, text = _a.text, button = _a.button, deviation = _a.deviation, width = _a.width, height = _a.height;
    var background = MediaService.getThumbSet(deviation).find(function (thumb) { return thumb.type === '400T'; });
    var fullImage = MediaService.getFullviewForSize(deviation, width, height);
    var childBoxSize = fullImage
        ? scaleToSize(fullImage, { width: width, height: height })
        : { width: width, height: height };
    return (React.createElement("div", { style: {
            width: width,
            height: height,
        }, className: s['root'] },
        React.createElement("div", { style: childBoxSize, className: s['blocked-placeholder'] },
            background && React.createElement(BlurredBackground, { imageUrl: background.src }),
            React.createElement("div", { className: s['blocked-wrap'] },
                React.createElement("div", { className: s['blocked-icon'] }, icon),
                title && React.createElement("div", { className: s['blocked-title'] }, title),
                text && React.createElement("div", { className: s['blocked-text'] }, text),
                button))));
};
PaywallLayout.displayName = 'PaywallLayout';
export default PaywallLayout;
//# sourceMappingURL=PaywallLayout.js.map